<template>
    <div style="height: 480px;" id="containerDiv" class="vs-con-loading__container">

        <div style="position: absolute;" class="m-2" v-if="inputDisabled">
            <!--<h4>Hello from registration terminal {{$route.params.access_key}} {{$t('Tasks')}}</h4>-->
            <h4 style="float: left">{{userName}}</h4>
        </div>

        <div style="position: absolute; top: 5px; right: 10px">
            <div v-if="online">
                <vs-chip color="success">Online</vs-chip>
            </div>
            <div v-else>
                <vs-chip color="danger">Offline</vs-chip>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-4/12">

                <div class="vx-row p-3" style="margin-top: 120px">
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(1)">1</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(2)">2</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(3)">3</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(4)">4</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(5)">5</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(6)">6</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(7)">7</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(8)">8</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(9)">9</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="danger" size="large" @click="clearField()">X</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="rgb(30, 30, 30)" size="large" @click="addToCode(0)">0</vs-button>
                    </div>
                    <div class="vx-col w-1/3 mb-3">
                        <vs-button :disabled="inputDisabled || !online" color="success" size="large" @click="keyboardEnter()">&#9166;</vs-button>
                    </div>
                </div>

                <vs-button v-if="inputDisabled" color="danger" class="ml-3" size="large" style="margin-top: 60px" @click="inputDisabled=false">{{$t("Cancel")}}</vs-button>

            </div>

            <div class="vx-col w-8/12 flex">

                <div style="margin-top:210px; margin-left: 150px" v-if="!inputDisabled">
                    <vs-input :disabled="!online" v-model="enterCode" onblur="this.focus()" ref="codeInput" autofocus @keyup.enter="rfidEnter()"/>
                </div>

                <div v-else class="w-full">
                    <div class="vx-row w-full flex justify-around" style="margin-top:140px">
                        <div class="vx-col w-1/2" v-if="userStatus === 0 || userStatus === 2">
                            <vx-card card-background="success" @click="enterButton">
                                <div slot="no-body">
                                    <div class="flex justify-around">
                                        <h1 class="p-6" style="color: white">{{$t("TerminalEnter")}}</h1>
                                    </div>
                                    <div class="flex justify-around">
                                        <log-in-icon icon="icon-log-in" :size="'100'" style="color: white" class="mb-6"/>
                                    </div>

                                </div>
                            </vx-card>
                        </div>
                        <div class="vx-col w-1/2" v-if="userStatus === 1">
                            <vx-card card-background="primary" @click="pauseButton">
                                <div slot="no-body" >
                                    <div class="flex justify-around">
                                        <h1 class="p-6" style="color: white">{{$t("TerminalPause")}}</h1>
                                    </div>
                                    <div class="flex justify-around">
                                        <pause-icon icon="icon-log-in" :size="'100'" style="color: white" class="mb-6"/>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                        <div class="vx-col w-1/2" v-if="userStatus === 1 || userStatus === 2">
                            <vx-card card-background="danger" @click="leaveButton">
                                <div slot="no-body">
                                    <div class="flex justify-around">
                                        <h1 class="p-6" style="color: white">{{$t("TerminalLeave")}}</h1>
                                    </div>
                                    <div class="flex justify-around">
                                        <log-out-icon icon="icon-log-in" :size="'100'" style="color: white" class="mb-6"/>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>


                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import LogInIcon from "vue-feather-icons/icons/LogInIcon";
    import LogOutIcon from "vue-feather-icons/icons/LogOutIcon";
    import PauseIcon from "vue-feather-icons/icons/PauseIcon"

    export default {

        components: {
            LogInIcon,
            LogOutIcon,
            PauseIcon
        },
        data(){
            return {
                enterCode: "",
                inputDisabled: false,
                online: false,

                userStatus: 0,
                userId: 0,
                userName: "Rok Mihailović Krpan",

                pingTimer: '',
            }
        },
        methods: {

            addToCode(char){
                this.enterCode += char;
            },
            clearField(){
                this.enterCode = "";
            },
            pingManagement(){

                const thisIns = this;
                const loadPromise = this.$http.get('/api/terminal/v1/' + this.$route.params.access_key + '/ping');
                loadPromise.then(function () {
                    thisIns.online = true;
                }).catch(function () {
                    thisIns.online = false;
                });

            },
            keyboardEnter(){

                if(this.enterCode.length === 0) {
                    this.$printError(this.$t("RFIDErrSelectionOpen"));
                    return
                }

                this.$vs.loading({
                    container: "#containerDiv",
                    type: 'corners',
                    scale: 1
                });

                const thisIns = this;
                const loadPromise = this.$http.get('/api/terminal/v1/' + this.$route.params.access_key + '/user/pin/' + thisIns.enterCode);
                loadPromise.then(function (response) {
                    thisIns.inputDisabled = true;
                    thisIns.userStatus = response.data.status;
                    thisIns.userId = response.data.id;
                    thisIns.userName = response.data.name;
                }).catch(function () {
                    thisIns.$printError("");
                }).finally(function () {
                    thisIns.clearField();
                    thisIns.$vs.loading.close("#containerDiv > .con-vs-loading");
                })

            },
            rfidEnter(){

                if(this.enterCode.length === 0) {
                    this.$printError(this.$t("RFIDErrSelectionOpen"));
                    return
                }

                this.$vs.loading({
                    container: "#containerDiv",
                    type: 'corners',
                    scale: 1
                });

                const thisIns = this;
                const loadPromise = this.$http.get('/api/terminal/v1/' + this.$route.params.access_key + '/user/rfid/' + thisIns.enterCode);
                loadPromise.then(function (response) {
                    thisIns.inputDisabled = true;
                    thisIns.userStatus = response.data.status;
                    thisIns.userId = response.data.id;
                    thisIns.userName = response.data.name;
                }).catch(function () {
                    thisIns.$printError("");
                }).finally(function () {
                    thisIns.clearField();
                    thisIns.$vs.loading.close("#containerDiv > .con-vs-loading");
                })

            },
            enterButton(){

                this.$vs.loading({
                    container: "#containerDiv",
                    type: 'corners',
                    scale: 1
                });

                const thisIns = this;
                const loadPromise = this.$http.put('/api/terminal/v1/' + this.$route.params.access_key + '/user/action/' + this.userId + '/start');
                loadPromise.then(function () {
                    thisIns.$printSuccess(thisIns.$t("TerminalEnterSuccessful"));
                }).catch(function () {
                    thisIns.$printError(thisIns.$t("TerminalEnterFailed"));
                }).finally(function () {
                    thisIns.inputDisabled = false;
                    thisIns.$vs.loading.close("#containerDiv > .con-vs-loading");
                })

            },
            pauseButton(){

                this.$vs.loading({
                    container: "#containerDiv",
                    type: 'corners',
                    scale: 1
                });

                const thisIns = this;
                const loadPromise = this.$http.put('/api/terminal/v1/' + this.$route.params.access_key + '/user/action/' + this.userId + '/pause');
                loadPromise.then(function () {
                    thisIns.$printSuccess(thisIns.$t("TerminalPauseSuccessful"));
                }).catch(function () {
                    thisIns.$printError(thisIns.$t("TerminalPauseFailed"));
                }).finally(function () {
                    thisIns.inputDisabled = false;
                    thisIns.$vs.loading.close("#containerDiv > .con-vs-loading");
                })

            },
            leaveButton(){

                this.$vs.loading({
                    container: "#containerDiv",
                    type: 'corners',
                    scale: 1
                });

                const thisIns = this;
                const loadPromise = this.$http.put('/api/terminal/v1/' + this.$route.params.access_key + '/user/action/' + this.userId + '/stop');
                loadPromise.then(function () {
                    thisIns.$printSuccess(thisIns.$t("TerminalLeaveSuccessful"));
                }).catch(function () {
                    thisIns.$printError(thisIns.$t("TerminalLeaveFailed"));
                }).finally(function () {
                    thisIns.inputDisabled = false;
                    thisIns.$vs.loading.close("#containerDiv > .con-vs-loading");
                })

            }
        },
        watch: {

            inputDisabled(){
                if(!this.inputDisabled){
                    const thisIns = this;
                    this.$nextTick(function () {
                        thisIns.$refs.codeInput.focusInput();
                    });
                }
            },
            online(){
                if(!this.inputDisabled && this.online){
                    const thisIns = this;
                    this.$nextTick(function () {
                        thisIns.$refs.codeInput.focusInput();
                    });
                }
            }
        },
        beforeCreate() {

            this.$store.commit('SET_LANGUAGE', this.$route.params.lang);
            this.$store.dispatch('updateTheme', "light");

        },
        mounted() {
            this.$refs.codeInput.focusInput();
            this.pingManagement();
            this.pingTimer = setInterval(()=>{ this.pingManagement() }, 15000);
        }

    }

</script>
